import React, { FC } from 'react';
import { TouchableOpacity, Image } from 'react-native';
import Animated, { SharedValue } from 'react-native-reanimated';
import { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types.d';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { ACTIVE_THUMBNAIL_MARGIN, THUMBNAIL_MARGIN } from '@v2/components/imageHandling/constants';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { useThumbnailItemCalculations } from './hooks/useThumbnailItemCalculations';
import Preview from '@components/imageHandling/components/thumbnails';
import { useManageImage } from '@v2/components/imageHandling/components/ProgressiveImage/hooks/useManageImage';

export interface ThumbnailItemProps {
  image: ImageDocumentStoreItem;
  index: number;
  selectedIndex: number;
  scrollProgress?: SharedValue<number>;
  totalImages: number;
  onPress: (index: number) => void;
  C: ColorFunction;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

const ThumbnailItem: FC<ThumbnailItemProps> = ({
  image,
  index,
  selectedIndex,
  scrollProgress,
  onPress,
  C,
  scale = initialScale,
  font = initialFont,
}) => {
  const { animatedStyle, imageSource, isActive } = useThumbnailItemCalculations({ image, index, selectedIndex, scale, scrollProgress });

  const { angle } = useManageImage({ image, width: animatedStyle.width, height: animatedStyle.height });

  return (
    <TouchableOpacity activeOpacity={0.8} onPress={() => onPress(index)}>
      <Animated.View
        style={[
          animatedStyle,
          {
            marginHorizontal: scale(isActive ? ACTIVE_THUMBNAIL_MARGIN : THUMBNAIL_MARGIN, false),
            borderColor: C('System/Light/Blue'),
            borderRadius: scale(4),
            overflow: 'hidden',
          },
        ]}
      >
        {image.isDocument ? (
          <Preview {...{ item: image, small: true, scale, font }} />
        ) : (
          <Image
            source={{ uri: imageSource }}
            style={{
              width: '100%',
              height: '100%',
              transform: [{ rotate: `${angle}deg` }],
            }}
            resizeMode="cover"
          />
        )}
      </Animated.View>
    </TouchableOpacity>
  );
};

export default ThumbnailItem;
